const EVENTS = {
    SHOW_EVENT_MODAL: 'SHOW_EVENT_MODAL.DETAIL',
    DESTROY_EVENT_MODAL: 'EVENT.DESTROY_EVENT_MODAL',
    HANDLE_EVENT_DETAIL: 'EVENTS.HANDLE_EVENT_DETAIL',
    EVENT_LOAD_EVENT: 'EVENTS.LOAD',
    RELOAD_COMPONENTS: 'RELOAD_COMPONENTS',
};

export default EVENTS;